module.exports = __webpack_public_path__ + "img/album23_01.0e221830.jpg";